<template>
  <loading
    :active.sync="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    background-color="#000"
    color="secondary"
    width.number="180"
    height.number="180"
  />
</template>
<script>
// import userAPIs from '../User/userAPIs'
import instagramAPIs from './instagramAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: { Loading },
  name: 'InstagramHandleIntegrate',
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    // Get code returned by Instagram
    const authCode = this.$route.query.code;
    const userID = this.$store.state.user.id;
    const facebookId = this.$store.state.user.facebookId;
    if (!authCode) {
      // Redirect to main page
      this.$router.push({ name: 'Profile' });
    } else {
      this.isLoading = true;
      instagramAPIs
        .handleInstagramIntegrateCallback(authCode, userID, facebookId)
        .then(response => {
          this.isLoading = false;
          const userData = response.userData;
          const jwtToken = response.jwtToken;
          // /* Setting user in the state and caching record to the localStorage */
          var token = 'Bearer ' + jwtToken;

          this.$store.commit('SET_USER', userData);
          this.$store.commit('SET_TOKEN', token);

          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(userData));
            window.localStorage.setItem('token', token);
          }

          this.$swal({
            title: 'Success',
            text: 'Your instagram has been connected.',
            type: 'success'
          }).then(() => {
            this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Profile' });
          });
        })
        .catch(() => {
          // Request failed.
          this.$swal({
            title: 'Error',
            text: 'Something went wrong! Can not connect to your instagram account',
            type: 'error'
          }).then(() => {
            this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Profile' });
          });
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// handleIntegrate.vue?0804d277